module.exports = __webpack_public_path__ + "static/media/Hero-bg.f600b864.jpg";